import Vue from 'vue';
import "./drag.scss";
Vue.directive('draggable', {
  bind(el, _binding, vnode) {
    // 弹窗
    const dragDom = el.querySelector('.el-dialog');
    // 初始非全屏
    dragDom.classList.add('v-drag-dialog');
    let isFullScreen = !!vnode.componentOptions.propsData.fullscreen;
    if (isFullScreen) return;

    // 弹框可拉伸最小宽高
    let minWidth = 400;
    let minHeight = 300;
    // 获取弹框头部（这部分可双击全屏）
    const dialogHeaderEl = el.querySelector('.el-dialog__header');
    dialogHeaderEl.style.cursor = 'move';
    dialogHeaderEl.style.userSelect = 'none';
    dialogHeaderEl.onmousedown = moveDown;
    // 给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    dragDom.style.overflow = "auto";
    let defaultStyleText;
    // 双击头部全屏效果
    dialogHeaderEl.ondblclick = () => {
      if (!isFullScreen) {
        defaultStyleText = dragDom.style.cssText;
        dragDom.style.height = "100VH";
        dragDom.style.width = "100VW";
        dragDom.style.marginTop = 0;
        dragDom.style.marginLeft = 0;
        dialogHeaderEl.style.cursor = 'initial';
        dialogHeaderEl.onmousedown = null;
        dragDom.onmousemove = null;
        dragDom.onmousedown = null;
        isFullScreen = true;
      } else {
        dragDom.style = defaultStyleText;
        dialogHeaderEl.style.cursor = 'move';
        dialogHeaderEl.onmousedown = moveDown;
        dragDom.onmousemove = onmouseMove;
        isFullScreen = false;
      }
    };
    dragDom.onmousemove = onmouseMove;
    let mouse_locate;
    // 弹框大小拖拽
    function onmouseMove(e) {
      if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10) {
        dragDom.style.cursor = 'w-resize';
      } else if (e.clientX < dragDom.offsetLeft + 10) {
        dragDom.style.cursor = 'w-resize';
      } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
        dragDom.style.cursor = 's-resize';
      } else {
        dragDom.style.cursor = 'default';
        dragDom.onmousedown = null;
      }
      dragDom.onmousedown = (e) => {
        const clientX = e.clientX;
        const clientY = e.clientY;
        const elW = dragDom.clientWidth;
        const elH = dragDom.clientHeight;
        const EloffsetLeft = dragDom.offsetLeft;
        const EloffsetTop = dragDom.offsetTop;
        minWidth = Math.min(minWidth, elW);
        minHeight = Math.min(minHeight, elH);
        // 如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;
        if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {
          return;
        }
        if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10) {
          mouse_locate = 'right';
        } else if (dragDom.offsetLeft + 10 > e.clientX) {
          mouse_locate = 'left';
        } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {
          mouse_locate = 'bottom';
        }
        if (!mouse_locate) return;
        dragDom.style.userSelect = 'none';
        dragDom.style.marginLeft = EloffsetLeft + 'px';
        document.onmousemove = function (e) {
          let nextWidth, nextHeight, nextLeft;
          e.preventDefault(); // 移动时禁用默认事件
          // 左侧鼠标拖拽位置
          if (mouse_locate === 'left') {
            nextWidth = elW + clientX - e.clientX;
            nextLeft = EloffsetLeft + e.clientX - clientX;
          } else if (mouse_locate === 'right') {
            // 右侧鼠标拖拽位置
            nextWidth = elW + e.clientX - clientX;
          } else if (mouse_locate === 'bottom') {
            // 往上拖拽
            nextHeight = elH + e.clientY - clientY;
          }
          if (nextWidth) {
            if (nextWidth < minWidth) return;
            dragDom.style.width = nextWidth + 'px';
          }
          if (nextHeight) {
            if (nextHeight < minHeight) return;
            dragDom.style.height = nextHeight + 'px';
          }
          if (nextLeft) {
            dragDom.style.marginLeft = nextLeft + 'px';
          }
        };
        // 拉伸结束
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
          mouse_locate = null;
          dragDom.style.userSelect = 'auto';
        };
      };
    }
    // 弹框拖拽移动
    function moveDown(e) {
      // 鼠标按下，计算当前元素距离可视区的距离
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      const [{ x, y }] = dragDom.getClientRects();
      const styL = x; const styT = y;
      document.onmousemove = function (e) {
        // 通过事件委托，计算移动的距离
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        // 移动当前元素
        dragDom.style.marginLeft = `${l + styL}px`;
        dragDom.style.marginTop = `${t + styT}px`;
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
        dragDom.style.userSelect = 'auto';
      };
    }
  }
});
